import { IControllerConstructor } from 'angular';
import { TransportLocationsUploadController } from './transport-locations-upload.controller';
import * as transportLocationsUploadRoutesModule from './transport-locations-upload.routes';
import { TransportLocationsPublisherController } from './publisher/transport-locations-publisher.controller';

export const initialise = () => {
  angular.module('app.transport-locations-upload', [
    'pascalprecht.translate',
    'actora.services',
    'app.layout',
    'app.components',
    
  ])
  .controller('transportLocationsUploadController', <IControllerConstructor>TransportLocationsUploadController)
  .controller('transportLocationsPublisherController', <IControllerConstructor>TransportLocationsPublisherController);

  transportLocationsUploadRoutesModule.initialise();
};